class JSModal {
  constructor(modalElement) {
    if (!(modalElement instanceof HTMLElement)) {

      console.warn('JSModal: No valid element was provided. The instance will be inactive.');
      this.isValid = false;
      return;
    }
    this.isValid = true;
    this.jsModal = modalElement;
    this.backdrop = null;
    this.isVisible = false;
    this._init();
  }
  _init() {
    this.jsModal.setAttribute('aria-hidden', 'true');
    this.jsModal.style.display = 'none';
    this.jsModal.classList.add('js-modal');
  
    const closeButtons = this.jsModal.querySelectorAll('[data-dismiss="js-modal"]');
    closeButtons.forEach(btn =>
      btn.addEventListener('click', () => this.hide())
    );
  }

  _dispatchEvent(eventName) {
    if (!this.isValid) return;
    const event = new CustomEvent(eventName, {
      detail: { modal: this.jsModal }
    });
    this.jsModal.dispatchEvent(event);
  }

  show() {
    if (!this.isValid || this.isVisible) return;
    this._dispatchEvent('jsmodal:show');
    this._createBackdrop();
    this.jsModal.style.display = 'block';
    this.jsModal.setAttribute('aria-hidden', 'false');
    setTimeout(() => {
      this.jsModal.classList.add('show');
      this.isVisible = true;
      this._dispatchEvent('jsmodal:shown');
    }, 10);
  }

  hide() {
    if (!this.isValid || !this.isVisible) return;
    this._dispatchEvent('jsmodal:hide');
    this.jsModal.classList.remove('show');
    this.jsModal.setAttribute('aria-hidden', 'true');
    this.isVisible = false;
  
    setTimeout(() => {
      this.jsModal.style.display = 'none';
      this._removeBackdrop();
      this._dispatchEvent('jsmodal:hidden');
    }, 300);
  }
  
  _createBackdrop() {
    this.backdrop = document.createElement('div');
    this.backdrop.className = 'js-modal-backdrop show';
    document.body.appendChild(this.backdrop);
  
    this.backdrop.addEventListener('click', () => this.hide());
  }

  _removeBackdrop() {
    if (this.backdrop) {
      this.backdrop.remove();
      this.backdrop = null;
    }
  }
}


  window.JSModal = JSModal;
  

  //********************Use Examples********************
  // const myModal = new JSModal(document.getElementById('myModal'));
  // myModal.show();
  // myModal.hide();
  // myModal.jsModal.addEventListener('jsmodal:shown', () => console.log('shown'));
  // myModal.jsModal.addEventListener('jsmodal:hidden', () => console.log('hidden'));